import InfoCircleFill from './InfoCircleFill';

export default InfoCircleFill;
